/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { DASHBOARD_STAT_WITH_PREVIOUS_FRAGMENT } from '@/graphql'

export const GET_AGGREGATE_DASHBOARD_STATS = gql`
  query AggregateDashboardStats($filters: DashboardFilter!) {
    aggregateDashboardStats(filters: $filters) {
      ...DashboardStatWithPrevious
    }
  }
  ${DASHBOARD_STAT_WITH_PREVIOUS_FRAGMENT}
`
